import React from "react";
import { upperFirst } from "lodash";
import Modal from "../../../common/Modal";
import Button from "../../../common/Button";
import saveBlobAsFile from "../../../utils/saveBlobAsFile";
import formModelStore from "../../../../store/FormModelStore";
import TWSCalculationApiService from "../../../../api-services/TWSCalculationApiService";
import APIServicesRegistry from "../../../../api-services/APIServicesRegistry";
import flattenConfigurationModel from "../../../../flattenConfigurationModel";
import { Calculation } from "../../../../../src/application/Contracts";
import TWSCalculationEditModel = Calculation.TWSCalculationEditModel;
import GenerateDocumentationModel = Calculation.GenerateDocumentationModel;
import DocumentationType = Calculation.DocumentationType;

export interface IGenDocModalBaseProps {
    isOpen: boolean;
    onClose: () => void;
}

export interface IGenDocModalBaseState {
    isSubmitting: boolean;
    isLoading: boolean;
    model: any;
    languageId: number;
}

export default class GenerateDocumentationModalBase<TProps extends IGenDocModalBaseProps, TState extends IGenDocModalBaseState> extends React.Component<TProps, TState> {
    private _calculationApiService: TWSCalculationApiService | null = null;

    constructor(props: TProps) {
        super(props);

        this.state = {
            isSubmitting: false,
            isLoading: true,
            model: {},
        } as TState;

        window.scheduleAtDocumentReady(() => {
            this._calculationApiService = APIServicesRegistry.getService(TWSCalculationApiService);
        });
    }

    UNSAFE_componentWillReceiveProps(nextProps: TProps) {
        if (nextProps.isOpen) {
            this.fetchModalData();
        }
    }

    private fetchModalData() {
        const data = this.getDocumentationModalContentData();
        this.setState({ isLoading: true }, () => {
            this._calculationApiService?.getDocumentationModalContent(data).then((response: any) => {
                this.thenFetchModalData(response);
            });
        });
    }

    protected getDocumentationModalContentData(): any {
        return {
            type: this.getDocumentType(),
            calculation: flattenConfigurationModel(formModelStore).formModel,
        };
    }

    protected thenFetchModalData(response: any) {
        this.setState({
            model: response.data,
            languageId: response.data.language.value,
            isLoading: false
        });
    }

    render() {
        return (
            <Modal width={this.getWidth()} isOpen={this.props.isOpen} onClose={this.props.onClose}>
                <Modal.Header>{__(upperFirst(this.getDocumentType()) + ' documentation')}</Modal.Header>
                <Modal.Body>
                    {this.state.isLoading ? (
                        <React.Fragment>
                            {__('Loading...')}
                        </React.Fragment>
                    ) : (
                        <React.Fragment>
                            {this.state.isSubmitting && (
                                <div className="loading-overlay" style={{ backgroundColor: '#ffffff' }}>
                                    <div className="ball-loader visible">
                                        <div className="ball-loader-ball1"></div>
                                        <div className="ball-loader-ball2"></div>
                                        <div className="ball-loader-ball3"></div>
                                    </div>
                                </div>
                            )}

                            {this.renderBody()}
                        </React.Fragment>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={this.props.onClose} theme={Button.Theme.BorderOnly}>
                        {__('Cancel')}
                    </Button>

                    <Button onClick={this.onSubmit} disabled={this.state.isSubmitting || this.isGenerateButtonDisabled()} theme={Button.Theme.BorderOnly}>
                        {__(this.state.isSubmitting ? 'Generating...' : 'Generate')}
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }

    protected getWidth(): string | null {
        return null;
    }

    protected getDocumentType(): DocumentationType {
        return DocumentationType.Calculation;
    }

    protected renderBody(): React.ReactNode {
        return (
            <>
            </>
        );
    }

    private onSubmit = () => {
        this.setState({ isSubmitting: true });
        let calculation: TWSCalculationEditModel = flattenConfigurationModel(formModelStore).formModel;

        this.executeAction(this.buildPostModel(calculation))?.then((response: any) => {
            saveBlobAsFile(response);

            this.props.onClose();
            this.setState({ isSubmitting: false });
        }).catch(() => {
            this.setState({ isSubmitting: false });
        });
    }

    private executeAction(data: any): Promise<any> {
        return this._calculationApiService?.generateDocumentation(data);
    }

    protected buildPostModel(calculation: TWSCalculationEditModel): GenerateDocumentationModel {
        return {
            projectId: undefined,
            documentations: [],
            technicalSpecification: undefined,
            twsOutcomes: [],
            language: this.state.languageId,
            publicPriceInclude: false
        };
    }

    protected isGenerateButtonDisabled(): boolean {
        return false;
    }
}